<template lang="pug">
  .vendor-upload-progress(v-loading="loading")
    title-bar
      span {{ $t('查看方案上传进度') }}
      el-button(
        v-if="showBriefCompletedButton && !isView"
        @click="onCompleteCurrentPhase"
        type="text"
        style="minWidth: 140px;font-size: 14px"
        :disabled="!tableData.vendor.some(d => d.status === 1) || ifExpired"
      ) {{ $t('完成当前节点') }}>>
    .vendor-upload-progress_end-Date
      span(style="margin-right: 30px") {{ $t('方案上传截止日期') }}
      span {{ tableData.deadline | formatDate }}
      el-tooltip(
        :content="$t('系统每天11点30分自动推进符合条件的项目')"
        placement="top"
        :style="{ marginLeft: '5px' }"
      )
        i.el-icon-question
    el-table.vendor-upload-progress_table(
      :data="tableData.vendor"
    )
      el-table-column(
        prop="vendor_name"
        :label="$t('供应商')"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          span {{ scope.row.vendor_name_ch }}/{{ scope.row.vendor_name }}
      el-table-column(
        prop="status"
        :label="$t('状态')"
      )
        template(slot-scope="scope")
          span {{ scope.row.status === 1 ?  $t('已上传') : $t('未上传') }}
      el-table-column(
        :label="$t('提交时间')"
      )
        template(slot-scope="scope")
          span {{ scope.row.plan_datetime | dateFormatter }}
      el-table-column(
        prop="category"
        :label="$t('方案')"
        show-overflow-tooltip
      )
        template(slot-scope="scope")
          a(
            v-if="scope.row.file_name"
            :style="{ color: '#00a0e5', cursor: 'pointer' }"
            :href="scope.row.download_url"
            target="_blank"
          ) {{ scope.row.file_name }}
          span(v-else) —
</template>

<script>
import TitleBar from '@/components/TitleBar'
import axios from 'axios'
import FooterButton from '@/components/FooterButton'
import { dateFormatter, formatDate } from '@/umcc/util'
import dayjs from 'dayjs'

export default {
  data () {
    return {
      tableData: {
        vendor: []
      },
      loading: false
    }
  },
  computed: {
    campaignID () {
      return this.$store.state.campaign.id
    },
    showBriefCompletedButton () {
      return this.$store.state.common.user.permissions.indexOf('Management_Brief_Completed_Button') !== -1
    },
    ifExpired () {
      return dayjs(dayjs(new Date()).format('YYYY-MM-DD')).unix() > dayjs(this.tableData.deadline).unix()
    }
  },
  mounted () {
    this.fetchData()
  },
  filters: {
    dateFormatter,
    formatDate
  },
  methods: {
    async fetchData () {
      const res = await axios.get('/management/campaign/getVendorProgressForProposal', {
        params: {
          campaign_id: this.campaignID
        }
      })
      this.tableData = res
      if (this.$store.state.campaign.taskId == null && res.task_id != null) {
        this.$store.commit('campaign/setTaskId', res.task_id)
      }
    },
    confirm () {
      this.loading = true
      axios.get('/management/campaign/v3/uploadProposalCompleted', {
        params: {
          campaign_id: this.campaignID,
          task_id: this.$store.state.campaign.taskId
        }
      }).then(res => {
        this.loading = false
        this.$store.dispatch('campaign/update', this.campaignID)
        this.$store.commit('campaign/setPhaseType', 1)
        this.$router.push('/campaign/process')
        this.$message.success(this.$t('确认成功'))
      })
    },
    onCompleteCurrentPhase () {
      this.$confirm(this.$t('当前节点将提前完成，请确定是否继续。'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消')
      })
        .then(() => {
          this.confirm()
        })
        .catch(() => {})
    }
  },
  components: {
    FooterButton,
    TitleBar
  }
}

</script>

<style lang="stylus">
.vendor-upload-progress_end-Date
  padding 0 30px
  .el-icon-question
    color $dark-blue

.vendor-upload-progress_table
  padding 22px 30px
  &:before
    content none

.vendor-upload-progress__footer
  padding 40px

.footer-button-group
  width 315px
  margin 30px auto
  display flex
  justify-content space-around

.title-bar
  display flex
  justify-content space-between
</style>
